import React, { useState, useEffect } from 'react';

import classnames from "classnames";
import {
    Button,
    ButtonGroup,
    Row,
    UncontrolledPopover,
    PopoverBody,
    Col,
    Modal,
} from "reactstrap";

function Situacoes({ value, onChange }) {

    const [situacoes] = useState([
        { id: 'todos', text: 'Todos' },        
        { id: 'somente_acoes', text: 'Ações' },
        { id: 'somente_notas', text: 'Notas' }
    ])


    return (
        <>
            <ButtonGroup className="btn-group-toggle mt-4 py--4" size='sm' data-toggle="buttons">
                {
                    situacoes.map((item, key) => (
                        <Button
                            className={classnames({ active: value == item.id })}
                            color="secondary"
                            onClick={() => onChange(item.id)}>
                            <input
                                autoComplete="off"
                                name="options"
                                type="radio"
                                value={value == item.id}
                            />
                            {item.text}
                        </Button>
                    ))
                }
            </ButtonGroup>
        </>
    )
}

export default Situacoes;